export default __webpack_public_path__ + "static/media/HaUyenTran.c92a908b.png";